export const regexMatchUrlWithLocation = /[-/]{1}in-([-\w]+)-(\w{2})\b/;

export const hasLocationInUrl = (url = ''): boolean => {
  if (typeof url === 'string') {
    const found = url.match(regexMatchUrlWithLocation);

    if (found?.length === 3) {
      return true;
    }
  }

  return false;
};

export const locationFromUrl = (
  url: string = ''
): { city?: string; state?: string } | undefined => {
  if (typeof url === 'string') {
    const found = url.match(regexMatchUrlWithLocation);

    if (found?.length === 3) {
      return { state: found[2], city: found[1] };
    }
  }

  return undefined;
};
